import { createContext } from "react";

export const NavTreeContext = createContext();
